module.exports = __webpack_public_path__ + "img/buliao.349cd0a0.svg";